const subUsersDE = {
    "view": {
        "table": {
            "title": "Ihre Liste der Unterbenutzer",
            "column": {
                "username": "Benutzername",
                "email": "E-Mail",
                "first_name": "Vorname",
                "last_name": "Nachname",
                "company": "Unternehmen",
                "sub_user_deal": "Deal (%)",
                "contract_expiry": "Vertragsablauf",
                "is_active": "Aktiv",
                "action": "Aktion"
            },
            "button": {
                "edit": "Bearbeiten",
                "export_csv": "CSV exportieren"
            },
            "placeholder": {
                "search": "Suche..."
            },
            "label": {
                "yes": "Ja",
                "no": "Nein"
            },
            "dropdown": {
                "action": "Aktion",
                "edit": "Bearbeiten",
                "activate": "Aktivieren",
                "deactivate": "Deaktivieren"
            }
        },
        "message": {
            "successUpdated": "Unterbenutzerkonto wurde aktualisiert!",
            "successActivated": "Unterbenutzerkonto wurde aktiviert!",
            "successDeactivated": "Unterbenutzerkonto wurde deaktiviert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!",
            "premiumUsersOnly": "Diese Funktion wird nur Premium-Nutzern angeboten. Bitte kontaktieren Sie das Support-Team, wenn Sie Ihr Konto upgraden möchten.",
            "noAccess": "Sie haben keinen Zugriff auf dieses Modul, bitte kontaktieren Sie das Support-Team für weitere Informationen."
        },
        "modal": {
            "activateSubuser": {
                "header": "Unterbenutzer aktivieren",
                "body": "Sind Sie sicher, dass Sie den Unterbenutzer {{username}} aktivieren möchten?"
            },
            "deactivateSubuser": {
                "header": "Unterbenutzer deaktivieren",
                "body": "Sind Sie sicher, dass Sie den Unterbenutzer {{username}} deaktivieren möchten?"
            },
            "button": {
                "cancel": "Abbrechen",
                "edit": "Bearbeiten",
                "activate": "Aktivieren",
                "deactivate": "Deaktivieren"
            }
        }
    },
    "add": {
        "title": "Unterbenutzer hinzufügen",
        "form": {
            "label": {
                "personalDetails": "Persönliche Details",
                "firstName": "Vorname",
                "lastName": "Nachname",
                "email": "E-Mail",
                "username": "Benutzername",
                "password": "Passwort",
                "confirmPassword": "Passwort bestätigen",
                "businessDetails": "Geschäftsdetails",
                "companyName": "Firmenname",
                "contractExpiry": "Vertragsablauf",
                "subUserDeal": "Unterbenutzer-Deal (%)",
                "nationalTaxNumber": "Steuernummer",
                "businessRegistrationNumber": "Handelsregisternummer",
                "contactDetails": "Kontaktdetails",
                "streetAndNumber": "Straße und Hausnummer",
                "postalCode": "Postleitzahl",
                "city": "Stadt",
                "country": "Land",
                "phoneNumber": "Telefonnummer"
            },
            "help_text": {
                "contractExpiry": "Hinweis: Das Vertragsablaufdatum kann nicht früher als {{afterOneYear}} festgelegt werden."
            },
            "button": {
                "submit": "Absenden"
            }
        },
        "message": {
            "success": "Unterbenutzer wurde hinzugefügt!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        },
        "modal": {
            "header": "Unterbenutzer hinzufügen",
            "body": "Sind Sie sicher, dass Sie einen neuen Unterbenutzer erstellen möchten?"
        }
    },
    "update": {
        "title": "Unterbenutzer bearbeiten",
        "form": {
            "label": {
                "personalDetails": "Persönliche Details",
                "firstName": "Vorname",
                "lastName": "Nachname",
                "email": "E-Mail",
                "username": "Benutzername",
                "password": "Passwort",
                "confirmPassword": "Passwort bestätigen",
                "businessDetails": "Geschäftsdetails",
                "companyName": "Firmenname",
                "contractExpiry": "Vertragsablauf",
                "subUserDeal": "Unterbenutzer-Deal (%)",
                "nationalTaxNumber": "Steuernummer",
                "businessRegistrationNumber": "Handelsregisternummer",
                "contactDetails": "Kontaktdetails",
                "streetAndNumber": "Straße und Hausnummer",
                "postalCode": "Postleitzahl",
                "city": "Stadt",
                "country": "Land",
                "phoneNumber": "Telefonnummer"
            },
            "help_text": {
                "contractExpiry": "Hinweis: Das Vertragsablaufdatum kann nicht früher als {{afterOneYear}} festgelegt werden."
            },
            "button": {
                "submit": "Absenden"
            }
        },
        "message": {
            "success": "Unterbenutzer wurde aktualisiert!",
            "error": "Etwas ist schief gelaufen! Bitte Seite aktualisieren und erneut versuchen!"
        }
    }
};

export default subUsersDE;